define('plugin/invoice/view/InvoiceTotalsView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Invoice totals view
     *
     * @class InvoiceTotalsView
     */
    return LayoutView.extend({

        template: '#invoice_totals_view',
        modelEvents: {
            'sync': 'safeRender'
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },
        
        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);
            
            if (result.taxes) {
                result.taxes = result.taxes.toJSON();
            }

            if (result.rest_amount > 0) {
                result.amount_with_rest_amount = result.rest_amount + result.amount;
            }

            return result;
        }

    });

});
